@for (additionalInfoItem of filteredAdditionalInfoItems; track trackByLabel($index, additionalInfoItem)) {
  <div>
    <div class="trigger"
      [ngClass]="additionalInfoItem.position">
      @if (additionalInfoItem.icon) {
        <img class="info-icon"
          [ngClass]="{'link': additionalInfoItem.location}"
          (click)="onTriggerClicked(additionalInfoItem.label)"
          src="{{additionalInfoItem.icon}}"/>
      }
      @if (additionalInfoItem.location) {
        <span
          class="link"
          [ngClass]="{'visible-layer-link': visibleComponents.includes(additionalInfoItem.label)}"
          (click)="onTriggerClicked(additionalInfoItem.label)">
          {{additionalInfoItem.label}}
        </span>
      }
      @if (!additionalInfoItem.location) {
        <span>
          {{additionalInfoItem.label}}
        </span>
      }
    </div>
    <div #loadedComponent></div>
  </div>
}
<div style="display: none;"><div #componentsContainer></div></div>
